/* eslint-disable no-unused-vars */
const ON_CHANGE_DEBOUNCE_TIMER = 300;
const subscribers = {};
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  variantChange: 'variant-change',
  productATC: 'product-atc',
  optionChange: 'option-change'
};

class EventBus {
  constructor() {
      this.subscribers = {}; // Object to hold event subscribers
  }

  // Subscribe to an event
  subscribe(eventName, callback) {
      if (this.subscribers[eventName] === undefined) {
          this.subscribers[eventName] = [];
      }

      // Add the callback to the list of subscribers for the event
       if (!this.subscribers[eventName].includes(callback)) {
        this.subscribers[eventName].push(callback);
      }

      // Return an unsubscribe function
      return () => {
          this.subscribers[eventName] = this.subscribers[eventName].filter((cb) => cb !== callback);
      };
  }

  // Publish an event
  publish(eventName, data) {
      if (this.subscribers[eventName]) {
          this.subscribers[eventName].forEach((callback) => {
              callback(data);
          });
      }
  }
}

const eventBus = new EventBus();
window.isMobileSafari = function() {
    const ua = navigator.userAgent;
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    const isMobile = /iPhone|iPad|iPod/i.test(ua);
    return isSafari && isMobile;
  }
  